export default __webpack_public_path__ + "static/media/logo-small.a4308448.svg";